"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _componentsBase = require("@telus-uds/components-base");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const withClientTheme = Component => {
  const UdsStyledComponent = _ref => {
    let {
      tokens: tokenOverrides,
      variant,
      ...props
    } = _ref;
    const theme = (0, _componentsBase.useThemeTokens)(Component.displayName, tokenOverrides, variant);
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(Component, {
      theme: theme,
      ...props
    });
  };
  UdsStyledComponent.propTypes = {
    tokens: (0, _componentsBase.getTokensPropType)(Component.displayName),
    variant: _propTypes.default.string
  };
  return UdsStyledComponent;
};
var _default = exports.default = withClientTheme;